<template>
  <div class="error_box">
      <div class="header_warpper">
          <div class="left">
              <!-- <div class="logo"></div> -->
              <div class="title">404 {{$t('other.a383')}}</div>
             
          </div>
          <div class="right">
            
          </div>
      </div>
      <div class="center">
        <div  class="LOGO">: (  </div>
        <div  class="success">{{$t('other.a384')}}</div>
        <div  class="login" @click="backTo()">{{$t('other.a385')}}</div>
            
      </div>
      
  </div>
</template>

<script>
import api from '../../src/api/moudles/shopaccess'
export default {
data(){
return{
    hasAccess:false,
    test:null,
    userPos:JSON.parse(localStorage.getItem('userInfo')).userPos
}
},
created(){
    this.init()
},
methods:{
    backTo(){
       console.log(this.userPos)
        if(this.userPos == 'SELLER'){
            this.$router.push({
                path:'/home'
            })
        }else if(this.userPos == 'STORE'){
            this.$router.push({
                path:'/sellerManagement'
            })
        }else{
             this.$router.push({
                path:'/loginPage'
            })
        }
    },
    init(){
        let url=location.href
        if(url.indexOf('?') > -1){
            let num=url.indexOf('?')
            let ttp=url.slice(num+1)
            console.log(ttp)
            let list=ttp.split('&')
            console.log(list)
            let params={
                code:list[0].slice(5),
                force:true,
                shop:list[3].slice(5).split('.')[0],
                userId:JSON.parse(localStorage.getItem('userInfo')).userId
            }

            api
            .bindShopify(params)
            .then(res => {
            if(res.code === 200 ){
            console.log('desc',res.data)
            this.hasAccess=true
             this.$message.success(this.$t('other.a382'))
            }else{
                this.hasAccess=false
                this.test=res.msg
            this.$message.warning(res.msg)
            }
            })

            console.log(params)
            

        }
        
    },
    goto(num){
        if(num == 0){
            this.$router.push('/index')
        }else if(num == 1){
             this.$router.push('/index')
        }else if(num == 2) {
            this.$router.push('/index')
        }else if(num == 3){
            this.$router.push('/index')
        }
    }

}
}

</script>
<style lang="scss" scoped>
.error_box{
    position: fixed;
    top: 0;
    left:0;
    right: 0;
    bottom: 0;
    background-color: #409eff;


    .vbfkh{
        color: rgb(0, 199, 163);
        font-size: 20px;
        margin-right: 15px;
    }

    .center{
        margin: 0 auto;
        width: 1200px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        min-height: 100vh;
        margin-bottom:-30px;


        .login{
            font-size: 20px;
            margin: 60px 0;
            color: #fff;
            cursor: pointer;
        }

        .oiin{
            margin-left: 40px;
            font-size: 35px;
        }

        .success{
            font-size: 35px;
            padding: 3px 15px;
            color: #fff;
        }

        .LOGO{
            font-size: 105px;
            padding: 43px 15px;
            color: #fff;
            text-align: left;
        }

        

        .vknf{
            display: flex;
            margin: 8px 0;
        }

        .vkjfmp{
            margin-right: 8px;
        }

        .desct{
            color: #409eff;
            margin: 5px 10px;
            font-size: 20px;
            cursor: pointer;
        }


    }
    

    .header_warpper{
        margin: 0 auto;
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 1200px;
        padding-bottom: 16px;
       


        .left{
            display: flex;
            align-items: center;
            padding-top: 30px;
          

            .title{
                font-size: 25px;
                font-weight: bold;
                color: #fff;
            }


            .logo{
                width: 30px;
                height: 15px;
                
                background-size: 100%;
                background-repeat: no-repeat;;
                background-image: url('../assets/img/h5_login.png');
            }
        }


        .right{
            display: flex;
            
            align-items: center;

            .desxc{
                line-height: 75px;
                height: 50px;
                font-size: 20px;
                font-weight: bold;
            }
        }


        .shopifylogo{
            width: 260px;
            height: 75px;
            background-image: url('../assets/img/shopify.png');
            background-size: 100%;
            background-repeat: no-repeat;;
        }

    }
}
</style>